import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InventoryKpi } from '@app/shared/components/inventory-toolbar/inventory-toolbar.component';

export type ListKpi = InventoryKpi;

/**
 * Indicadores de una lista (mismo diseño que los del inventario de insumos):
 * icono + número + etiqueta. Al darles clic filtran la lista; "Total" (o volver
 * a dar clic en el activo) quita el filtro.
 */
@Component({
  selector: 'app-kpi-strip',
  standalone: true,
  imports: [NgClass, MatIconModule, MatTooltipModule],
  template: `@if (kpis.length) {
<div class="kpi-strip">
  @for (k of kpis; track k.key) {
    <button type="button" class="kpi" [class.kpi--active]="active === k.key" [ngClass]="'kpi--' + (k.tone ?? 'neutral')"
            [matTooltip]="k.isTotal ? 'Quitar el filtro y ver todo' : 'Filtrar por ' + k.label.toLowerCase()"
            (click)="onClick(k)">
      <mat-icon class="kpi__icon">{{ k.icon }}</mat-icon>
      <span class="kpi__value">{{ k.value }}</span>
      <span class="kpi__label">{{ k.label }}</span>
    </button>
  }
</div>
}`,
  styles: [`
    .kpi-strip {
      display: grid; grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
      gap: 12px; margin: 4px 20px 14px;
    }
    .kpi {
      display: flex; align-items: center; gap: 10px; padding: 14px 16px;
      background: #ffffff; border: 1px solid #e8e8e8; border-radius: 12px;
      cursor: pointer; text-align: left; font: inherit;
      transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease;
    }
    .kpi:hover { transform: translateY(-2px); box-shadow: 0 6px 18px rgba(0,0,0,.08); }
    .kpi--active { border-color: #1010eb; background: rgba(40, 94, 255, 0.06); box-shadow: inset 0 0 0 1px #1010eb; }
    .kpi__icon {
      flex: 0 0 auto; width: 34px; height: 34px; font-size: 20px; line-height: 34px;
      display: inline-flex; align-items: center; justify-content: center;
      border-radius: 10px; background: #f4f4f4; color: #170f5f;
    }
    .kpi--ok     .kpi__icon { background: rgba(20, 133, 61, .10); color: #14853d; }
    .kpi--warn   .kpi__icon { background: rgba(207, 80, 9, .14);  color: #cf5009; }
    .kpi--danger .kpi__icon { background: rgba(16, 16, 235, .10); color: #1010eb; }
    .kpi__value { font-size: 1.35rem; font-weight: 700; color: #170f5f; line-height: 1; }
    .kpi__label { font-size: .8rem; color: #555555; line-height: 1.2; }
    @media (max-width: 768px) { .kpi-strip { grid-template-columns: repeat(2, 1fr); } }
  `],
})
export class KpiStripComponent {
  @Input() kpis: ListKpi[] = [];
  @Input() active: string | null = null;
  @Output() activeChange = new EventEmitter<string | null>();

  onClick(k: ListKpi): void {
    if (k.isTotal) { this.activeChange.emit(null); return; }
    this.activeChange.emit(this.active === k.key ? null : k.key);
  }
}
